//<!----- Collection Carousel Section JavaScript Code Start -----> //

var swiper = new Swiper('.collection .swiper-slider', {
  slidesPerView: 3,
  loop: true,
  spaceBetween: 15,
  centeredSlides: false,
  autoHeight: true,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  //   speed: 100
  // },
 pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    750: {
      slidesPerView: 3,
    }
  }
});

//<!----- Collection Carousel Section JavaScript Code End -----> //

//<!----- Scroll Top Button JavaScript Code Start -----> //

document.addEventListener('DOMContentLoaded', function () {
  const scrollBtn = document.getElementById('scroll-top-container');

  if (!scrollBtn) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 200) {
      scrollBtn.classList.add('show');
    } else {
      scrollBtn.classList.remove('show');
    }
  });

  scrollBtn.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});

//<!----- Scroll Top Button JavaScript Code End -----> //

//<!----- Header Dropdown Open On Hover JavaScript Code Start -----> //

document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth >= 990) {
    const details = document.querySelectorAll(".wordpress-customer header-menu details");

    details.forEach(detail => {
      const summary = detail.querySelector("summary");

      detail.addEventListener("mouseenter", () => {
        detail.setAttribute("open", "");
        summary.setAttribute("aria-expanded", "true");
      });

      detail.addEventListener("mouseleave", () => {
        detail.removeAttribute("open");
        summary.setAttribute("aria-expanded", "false");
      });

      summary.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  }
});

//<!----- Header Dropdown Open On Hover JavaScript Code End -----> //

 document.addEventListener("DOMContentLoaded", function() {
    // document.getElementById('openKlaviyoFormBtn').addEventListener('click', function(e) {
     const openKlaviyoFormBtn = document.getElementById('openKlaviyoFormBtn');
    
    if (openKlaviyoFormBtn) {
      openKlaviyoFormBtn.addEventListener('click', function(e) {
        e.preventDefault();
        // Trigger Klaviyo form with ID SuwtE3
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SuwtE3']);
      });
    }
  });